import { xpThreshold } from './progression.js';
/**
 * The price of falling (ROADMAP Phase 3: "malus léger"): a tenth of the
 * experience earned inside the current level. Never a level lost, never the
 * gold or the gear — dying should sting, not undo an evening.
 */
export const DEATH_XP_SHARE = 0.1;
export function deathPenalty(progress) {
    const floor = xpThreshold(progress.level);
    const intoLevel = Math.max(0, progress.xp - floor);
    const xpLost = Math.floor(intoLevel * DEATH_XP_SHARE);
    return { xp: progress.xp - xpLost, xpLost };
}
//# sourceMappingURL=death.js.map